export const AnalyticsEvent = {
  UserSignedUp: 'User Signed Up',
  UserLoggedIn: 'User Logged In',
  UserLoggedOut: 'User Logged Out',
  AvatarPageViewed: 'Avatar Page Viewed',
  FreeAvatarItemEquipped: 'Free Avatar Item Equipped',
  AvatarItemPurchased: 'Avatar Item Purchased',
  AvatarSelected: 'Avatar Selected',
  LessonStarted: 'Lesson Started',
  LessonCompleted: 'Lesson Completed',
  ActivityStarted: 'Activity Started',
  ActivityResumed: 'Activity Resumed',
  ActivityCompleted: 'Activity Completed',
  ActivityReportViewed: 'Activity Report Viewed',
  TaskSubmitted: 'Task Submitted',
  LeaderboardViewed: 'Leaderboard Viewed',
} as const;
